package com.milta.core.localization.translations.pl

import com.milta.core.localization.SubscriptionExpiredStrings

internal val SubscriptionExpired = SubscriptionExpiredStrings(
    title = "Abonament wygasł",
    driverSoloMessage = "Twój abonament wygasł. Odnów, aby kontynuować.",
    patronMessage = "Twój abonament wygasł. Twój zespół nie ma już dostępu do Milta.",
    driverUnderPatronMessage = "Abonament Twojej organizacji wygasł. Skontaktuj się ze swoją organizacją, aby przywrócić dostęp.",
    renewButton = "Odnów",
    close = "Zamknij",
    subscribeButtonTemplate = "Subskrybuj za %s",
    driverLinkCodeHint = "Pracujesz dla firmy? Przekaż jej ten kod: po powiązaniu będziesz objęty jej subskrypcją.",
    checkAccessButton = "Sprawdź mój dostęp",
    accessStillUnavailable = "Dostęp nadal niedostępny",
)
